import React from 'react';

export default ({theme = 'default', value, label, ...rest}) => (
	<label className={`Textarea Textarea--${theme}`+(rest.disabled ? ' Textarea--disabled' : '')}>
		<h6>{label}</h6>
		<textarea value={value || ''} {...rest}/>
	</label>
);